/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddressV1Dto } from '../models/AddressV1Dto';
import type { CreateAddressV1Dto } from '../models/CreateAddressV1Dto';
import type { DeleteManyRequestV1 } from '../models/DeleteManyRequestV1';
import type { DeleteManyResultV1 } from '../models/DeleteManyResultV1';
import type { PatchAddressV1Dto } from '../models/PatchAddressV1Dto';
import type { UpdateAddressV1Dto } from '../models/UpdateAddressV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AddressesService {
  /**
   * @param requestBody
   * @returns AddressV1Dto create entity
   * @throws ApiError
   */
  public static addressControllerV1CreateV1(
    requestBody: CreateAddressV1Dto,
  ): CancelablePromise<AddressV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/addresses',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @returns AddressV1Dto a entity list
   * @throws ApiError
   */
  public static addressControllerV1FindAllV1(): CancelablePromise<Array<AddressV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/addresses',
      errors: {
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static addressControllerV1RemoveManyV1(
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/addresses',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param uuid addressId
   * @returns AddressV1Dto the entity
   * @throws ApiError
   */
  public static addressControllerV1FindOneV1(uuid: string): CancelablePromise<AddressV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/addresses/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @deprecated
   * @param uuid addressId
   * @param requestBody
   * @returns AddressV1Dto the update entity
   * @throws ApiError
   */
  public static addressControllerV1UpdateV1(
    uuid: string,
    requestBody: UpdateAddressV1Dto,
  ): CancelablePromise<AddressV1Dto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/v1/addresses/{uuid}',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param uuid addressId
   * @param requestBody
   * @returns AddressV1Dto the update entity
   * @throws ApiError
   */
  public static addressControllerV1UpdatePartialV1(
    uuid: string,
    requestBody: PatchAddressV1Dto,
  ): CancelablePromise<AddressV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/addresses/{uuid}',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param uuid addressId
   * @returns AddressV1Dto the entity
   * @throws ApiError
   */
  public static addressControllerV1RemoveOneV1(uuid: string): CancelablePromise<AddressV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/addresses/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
}
